import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

// Async thunk for checking user authorization
export const checkUserAuthorization = createAsyncThunk(
  'auth/checkUserAuthorization',
  async (_, { getState, dispatch, rejectWithValue }) => {
    const state = getState();
    const token = localStorage.getItem('token');

    if (!token) {
      return rejectWithValue('No token found');
    }

    try {
      // Fetch user details with authorization check
      const response = await axios.get(`${API_BASE_URL}/auth/user/${state.auth.id}`, {
        headers: { 
          'Authorization': `Bearer ${token}` 
        }
      });

      // Additional authorization check can be performed here
      const isAuthorized = response.data.user.isAuthorized ?? false;

      return {
        user: response.data.user,
        isAuthorized: isAuthorized
      };
    } catch (error) {
      // Handle authorization failure
      dispatch(logout());
      return rejectWithValue(error.response?.data?.message || 'Authorization failed');
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    id: null,
    username: "",
    role: null,
    locationid: null,
    isAuthenticated: false,
    isAuthorized: false,
    lastActivityTimestamp: null,
    authorizationChecking: false,
    authorizationError: null
  },
  reducers: {
    login(state, action) {
      const now = Date.now();
      state.id = action.payload.id;
      state.username = action.payload.username;
      state.role = action.payload.role;
      state.locationid = action.payload.locationid;
      state.isAuthenticated = true;
      state.isAuthorized = action.payload.isAuthorized ?? false;
      state.lastActivityTimestamp = now;
    },
    logout(state) {
      state.id = null;
      state.username = "";
      state.role = null;
      state.locationid = null;
      state.isAuthenticated = false;
      state.isAuthorized = false;
      state.lastActivityTimestamp = null;
    },
    updateLastActivity(state) {
      state.lastActivityTimestamp = Date.now();
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkUserAuthorization.pending, (state) => {
        state.authorizationChecking = true;
        state.authorizationError = null;
      })
      .addCase(checkUserAuthorization.fulfilled, (state, action) => {
        state.authorizationChecking = false;
        state.isAuthorized = action.payload.isAuthorized;
        state.authorizationError = null;
      })
      .addCase(checkUserAuthorization.rejected, (state, action) => {
        state.authorizationChecking = false;
        state.isAuthorized = false;
        state.authorizationError = action.payload;
      });
  }
});

export const { 
  login, 
  logout, 
  updateLastActivity 
} = authSlice.actions;
export default authSlice.reducer;